/* eslint-disable @typescript-eslint/no-explicit-any */

import RootEngine from './RootEngine'
import { configure, toJS } from 'mobx'

configure({ enforceActions: 'never' })

declare global {
  const lintrk: any
  const twq: any
  const HellonextWidget: any
  const entri: any
  interface Window {
    engine: RootEngine
    tojs: typeof toJS
    Rewardful: any
    displayPreferenceModal: any
    HellonextWidget: any
  }
}

let engine: RootEngine

// In production, just create the engine normally
if (!import.meta.hot) {
  engine = new RootEngine()
  if (typeof window !== 'undefined') {
    window.engine = engine
    window.tojs = toJS
  }
} else {
  // In development with HMR, preserve the engine instance across updates
  if (typeof window !== 'undefined' && window.engine) {
    // Reuse existing engine from window (persists across HMR naturally)
    engine = window.engine
  } else if (import.meta.hot.data.engine) {
    // Fallback to HMR data (shouldn't normally happen if window.engine exists)
    engine = import.meta.hot.data.engine
    if (typeof window !== 'undefined') {
      window.engine = engine
    }
  } else {
    // Only create on very first load
    engine = new RootEngine()
    if (typeof window !== 'undefined') {
      window.engine = engine
      window.tojs = toJS
    }
  }

  // Set up HMR disposal handler
  import.meta.hot.dispose((data) => {
    // Save the engine before the module is replaced
    data.engine = window.engine
  })
}

// Expose toJS on window for debugging (in case it wasn't set above)
if (typeof window !== 'undefined' && !window.tojs) {
  window.tojs = toJS
}

export default engine
